import { render, staticRenderFns } from "./_TagFormImportar.vue?vue&type=template&id=1e941632&scoped=true"
import script from "./_TagFormImportar.vue?vue&type=script&lang=ts"
export * from "./_TagFormImportar.vue?vue&type=script&lang=ts"
import style0 from "./_TagFormImportar.vue?vue&type=style&index=0&id=1e941632&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e941632",
  null
  
)

export default component.exports